import 'client-only'

import getAmplifyConfig from './amplify-config'
import { Amplify } from 'aws-amplify'

export default function initAmplifyClient() {
  Amplify.configure(getAmplifyConfig())
}
